﻿import React from "react";
import { LegalEntityScope } from "./legalEntities/LegalEntities.types.ts";
import MicroFrontend from "../microFrontend/MicroFrontend.tsx";
import { useParams } from "react-router";
import { DotLegalPageHeader } from "@dotlegal/dotlegal-ui-components";
import { useLegalEntityBreadCrumbs } from "./useLegalEntityBreadCrumbs.ts";
import { SelectableItem } from "../processingActivity/ProcessingActivity.types.ts";
import { useUserContext } from "../auth/userContextProvider/UserContextProvider.tsx";
import { useTranslation } from "../localization/useTranslation.ts";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export interface ILegalEntityClassificationProps {
    legalEntityScope: LegalEntityScope;
}

function LegalEntityClassification(props: ILegalEntityClassificationProps) {
    const { translateString } = useTranslation();
    const { id } = useParams<{ id: string }>();
    const url = `/legalEntity/${id}/light`;
    const { customerName } = useUserContext();
    let { data } = useDotLegalQuery<SelectableItem>(url);
    let breadCrumbs = useLegalEntityBreadCrumbs(props.legalEntityScope, {
        name: data?.name ?? "",
        id: data?.id ?? "",
    });
    breadCrumbs = [...breadCrumbs, { name: translateString("classification") }];
    return (
        <>
            <DotLegalPageHeader breadCrumbs={breadCrumbs} />
            <MicroFrontend />
        </>
    );
}

export default LegalEntityClassification;
